import React from "react";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader } from "@/components/shared";

export default function ContentWriting() {
  const [active, setActive] = React.useState("activity");
  const TABS = [
    { id: "activity", label: "Activity & KPIs" },
    { id: "log", label: "Detailed Log" },
  ];
  return (
    <div>
      <PageHeader title="Content Writing" subtitle="Writers log pieces → auto KPIs (published, approved, on-time)" />
      <div className="flex gap-1 mb-6 border-b border-surface-hover">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`tab-${t.id}`} onClick={() => setActive(t.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors duration-200 ${active === t.id ? "border-gold text-gold" : "border-transparent text-slatetext hover:text-white"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {active === "activity" ? <ActivityModule module="content_writing" /> : <TrackerTable id="content-writing" />}
    </div>
  );
}
